import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Trans, useTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';
import BulletHeader from '../../../components/BulletHeader/BulletHeader';
import Card from '../../../components/Card/Card';

// CSS Files
import './styles.css';

const CategorySelection = (props) => {
   const { t } = useTranslation();

   const submit = (data) => {
      props.onSubmit(data)
   }

   return (
      <div>
         <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton/>

         <Container className={"desktop"}>
            <Row className={"mb-2"}>
               <Col className={"pb-3"} xs={12} sm={12}>
                  <BulletHeader text={t("registration_page.category")}/>
                  <p><Trans i18nKey="registration_page.category_note" components={{ br: <br /> }}/></p>
               </Col>
            </Row>
            <Row>
               {props.formData.isLeague ? (

                  props.formData.league_categories.map((leagueCategory, key) => {
                     let previous_page = window.location.href;

                     return <Card key={key.toString()} onClick={() => submit({
                        league_category_id: leagueCategory.id,
                        category: leagueCategory.name,
                        previous_page: previous_page
                     })} text={leagueCategory.name}/>
                  })
               ) : (
                  props.formData.categories.map((category, key) => {
                     let previous_page = window.location.href;

                     return <Card key={key.toString()} onClick={() => submit({
                        category_id: category.id,
                        category_name: category.name,
                        previous_page: previous_page
                     })} text={category.name}/>
                  })
               )}
            </Row>
         </Container>
      </div>
   );
}

export default CategorySelection;